import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useCreacionTrasladoAlmacen } from "../hooks/useCreacionTrasladoAlmacen";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DatosAlmacen } from "./DatosAlmacen";
import { Recepciones } from "./Recepciones";
import { useForm } from "react-hook-form";
import { ConfirmacionTraslado } from "./ConfirmacionTraslado";

export const AlmacenForm = (props) => {
    const { almacenId, regresar } = props;

    const { almacenDetalle, cargando } = useCreacionTrasladoAlmacen(
        almacenId,
        regresar,
    );

    const {
        control: formControl,
        register: formRegister,
        setValue: formSetValue,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
    });

    const [movimientoSeleccionado, setMovimientoSeleccionado] = useState(null);

    const PedirConfirmacionTraslado = async (movimiento) => {
        // Si el movimiento ya pertenece a un inventario cerrado, no permitir el traslado
        if (!!movimiento.inventario_cerrado) {
            let msg = `El movimiento seleccionado pertenece al inventario cerrado ID: ${movimiento.inventario_cerrado}.`;
            msg += " No es posible realizar el traslado.";

            NotificationManager.error(msg, "Error", 3000);
            return;
        }

        const isValid = await validateForm();
        if (!isValid) {
            // hacer scroll hacia arriba para mostrar los errores
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        setMovimientoSeleccionado(movimiento);
    };

    const [refreshKey, setRefreshKey] = useState(0);

    const RefreshRecepciones = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <LoadMask loading={cargando} blur>
            <DatosAlmacen
                datosAlmacen={almacenDetalle}
                formControl={formControl}
                formErrors={formErrors}
            />
            <Recepciones
                almacenId={almacenId}
                PedirConfirmacionTraslado={PedirConfirmacionTraslado}
                refreshKey={refreshKey}
            />
            <ConfirmacionTraslado
                movimientoSeleccionado={movimientoSeleccionado}
                onClose={() => setMovimientoSeleccionado(null)}
                almacenOrigen={almacenDetalle}
                almacenDestino={formGetValues().almacen_destino}
                onSuccess={RefreshRecepciones}
            />
        </LoadMask>
    );
};
